module.exports = __webpack_public_path__ + "static/media/book-demo.c94047d7.svg";